import { render } from "./UserCreating.vue?vue&type=template&id=22bb1b1b&ts=true"
import script from "./UserCreating.vue?vue&type=script&lang=ts"
export * from "./UserCreating.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__